import { PointIcon } from '../../Assets';
import { Service } from '../Service';
import { PointTool, TransformWidgetTool } from './Tool';
/**
 * API for enabling the transformation tools to manipulate the position and orientation of a model in space.
 */
export class TransformService extends Service {
    constructor(modules, navigationService) {
        super(modules);
        Object.defineProperty(this, "navigationService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.navigationService = navigationService;
    }
    /**
     * Start the transform widget tool on a 3D target.
     *
     * @param target
     */
    createWidgetTool(target) {
        return new TransformWidgetTool(target, this.widgetManager, this.navigationService);
    }
    /**
     * Start the point placement tool on a 3D target.
     *
     * @param target
     */
    async createPointTool(target) {
        const spriteDesc = {
            position: {
                ecef: { x: 0, y: 0, z: 0 },
            },
            url: PointIcon,
            material: {
                type: 'basicAlpha',
                color: { r: 1, g: 1, b: 1 },
                alpha: 0.4,
            },
            sizeAttenuation: false,
            scale: { x: 0.03, y: 0.03, z: 0.03 },
        };
        const pointer = await this.renderer.getObjectFactory().createSprite(spriteDesc);
        return new PointTool(target, pointer, this.renderer, this.gestures);
    }
    updateFrame(deltaTime) { }
}
